import { useState } from "react";
import {
  ResponseGetRemarksTemplateResponse,
  RemarksTemplateApi,
  RequestDeleteRemarksTemplateRequest,
  RemarksTemplateDeleteRemarksTemplatePostRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiDeleteRemarksTemplate = () => {
  const [remarksTemplateList, setRemarksTemplateList] = useState<
    ResponseGetRemarksTemplateResponse[] | null
  >([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const deleteRemarksTemplate = async (
    req: RequestDeleteRemarksTemplateRequest,
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: RemarksTemplateDeleteRemarksTemplatePostRequest = {
        req,
      };

      const api = new RemarksTemplateApi(config);
      const response =
        await api.remarksTemplateDeleteRemarksTemplatePost(request);
      setRemarksTemplateList(response);
      return response;
    } catch (err: any) {
      setError("備考の削除に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { deleteRemarksTemplate, remarksTemplateList, error, isLoading };
};
